import React, { Component,useState } from 'react';
import Button from '@mui/material/Button';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import "../../../index.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import * as apiDashBoardService from '../../NewProcess/apiRequestService';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import PendingIcon from '@mui/icons-material/Pending';
import Moment from 'moment';
import {getApprovalDetail, cancelApproval} from '../../NewProcess/apiRequestService';
import styles from '../style.js';
import Stepper from '../../ui/Stepper';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {DownloadFile, DownloadZipFile} from '../../../utils/fileOperation';
import CancelDialog from './CancelDialog';
class DetailPage extends Component {
 

  constructor(props) {
    super(props);
    this.state = {
      BoxClass:{
        boxShadow: 12
      },
      processInfos:[],
      processDetails:[],
      processSigners:[],
      selectedValue:{},
      cancelReason:"",
      steps : [
        'Süreç Başlangıcı',
        'Süreç Onayları',
        'Süreç Sonucu',
      ],
      activeStep:1,
      isCancelDialogOpen:false,
      isCancelAuth: false
    };
  }

  componentDidMount() {
    const {selectedId}=this.props;

    getApprovalDetail(selectedId)
    .then((response) => {
        this.setState({selectedValue: response.data}, () => {this.fillPageDetails();});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Detay bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getApprovalDetail exception: ' + JSON.stringify(exception));
    });
  }

  fillPageDetails() {  
    const{selectedValue}=this.state;

    let rows = [
      {name:"Süreç Adı",detail:selectedValue.name},
      {name:"Süreç Grubu",detail:!_.isNil(selectedValue.processTypeDetail) && !_.isNil(selectedValue.processTypeDetail.processGroup)?
      selectedValue.processTypeDetail.processGroup.name:''},
      {name:"Süreç Türü",detail:!_.isNil(selectedValue.processTypeDetail)?selectedValue.processTypeDetail.processTypeName:''},
      {name:"İmzalama Sırası",detail:selectedValue.signOrderTitle},
      {name:"Süreç Sonu Eylemi",detail:selectedValue.endOperationActionTitle}
    ]
    this.setState({processInfos:rows});

    let detailRows = [
      {name:"Süreç Bilgilendirme",detail:selectedValue.notificationTypeTitle},
      {name:"Süreç Sonu Bilgilendirme",detail:selectedValue.endProcessNotificationTypeTitle},
      {name:"Süreç Kayıt Tarihi",detail:Moment(selectedValue.createdDate).format('DD/MM/YYYY HH:mm')},
      {name:"Süreç Oluşturan",detail:selectedValue.createdUser},
      {name:"Dosya Adı",detail:selectedValue.approvalFile.fileName}]
    this.setState({processDetails:detailRows});

    if (!_.isNil(selectedValue.internalSigners)) {
      let signerRows = [];
      for (let i = 0; i < selectedValue.internalSigners.length; i++) {
        let value=selectedValue.internalSigners[i];
        signerRows.push({
          name:value.userInfo.name,
          detail:value.signType.parameterName,
          recordStatus:value.recordStatus,
          updateDate:value.lastUpdatedDate});
      }
      this.setState({processSigners:signerRows});
    }
    if (selectedValue.createdUserId === selectedValue.userId){
      this.setState({isCancelAuth : true});
    }
  }

  handleViewDoc = () => {
    const { selectedValue } = this.state;
    
    Promise.all([
      apiDashBoardService.getApprovalFile(selectedValue.id),
      apiDashBoardService.getAdditionalFile(selectedValue.id),
    ])
      .then(([approvalFileResponse, additionalFileResponse]) => {
        const approvalFile = approvalFileResponse.data;
        const additionalFile = additionalFileResponse.data;
  
        if (!approvalFile) {
          throw new Error("Süreç dokümanı bulunamadı.");
        }
  
        const filesToDownload = [];
  
        filesToDownload.push({
          fileData: approvalFile.fileData,
          fileName: approvalFile.fileName,
          type: "approval",
        });
  
        if (additionalFile)
          filesToDownload.push({
            fileData: additionalFile.fileData,
            fileName: additionalFile.fileName,
            type: "additional",
          });
  
        if (filesToDownload.length === 1) {
          const file = filesToDownload[0];
          DownloadFile(file.fileData, file.fileName);
        } else {
          DownloadZipFile(filesToDownload);
        }
      })
      .catch((exception) => {
        this.props.actions.setNotification("Dosya bilgileri getirilemedi, daha sonra tekrar deneyin.", "error");
        console.log('handleViewDoc exception: ' + JSON.stringify(exception));
      });
  }

  handleChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });
  };

  handleCancel = () => {
    const{selectedValue}=this.state;
    this.setState({isCancelDialogOpen:true});
  }

  handleCloseCancelDialog() {
    this.setState({ isCancelDialogOpen: false });
  }

  handleApproveCancelDialog(ele) {

    const{selectedValue,cancelReason}=this.state;
    const {selectedItem}=this.props;

    if(_.isEmpty(cancelReason)){
      this.props.actions.setNotification('İptal açıklaması girilmesi zorunludur.', 'warning');
      return;
    }
    
    this.setState({ isCancelDialogOpen: false });
    apiDashBoardService.cancelApproval({id:selectedValue.id,cancelReason:cancelReason})
    .then((response) => {
      this.props.actions.setNotification("Başarılı bir şekilde iptal edildi", 'success');
      this.props.closeEditPage();
    })
    .catch((exception) => {
      this.props.actions.setNotification("İptal sırasında hata oluştu.", 'error');
      console.log('handleCancel exception: ' + JSON.stringify(exception));
    });
  }

  getUserIcon(recordStatus) {
    switch (recordStatus) {
      case "O":
        return (<TableCell sx={{width:"10%"}}><ThumbUpAltIcon sx={{color: "#57853f",fontSize: 30}}/></TableCell>);
      case "R":
        return (<TableCell sx={{width:"10%"}}><ThumbDownIcon sx={{color: "#ab3c3c",fontSize: 30}}/></TableCell>);
      default:
        return (<TableCell sx={{width:"10%"}}><PendingIcon sx={{color: "#ff8d00",fontSize: 30}}/></TableCell>);
    }
  }

  getUserApproveText(recordStatus,updateDate) {
    switch (recordStatus) {
      case "O":
        return (<TableCell><div style={styles.approveText}>Onaylandı</div><div style={styles.dateText}>{Moment(updateDate).format('DD/MM/YYYY HH:mm')}</div></TableCell>);
      case "R":
        return (<TableCell><div style={styles.rejectText}>Reddedildi</div><div style={styles.dateText}>{Moment(updateDate).format('DD/MM/YYYY HH:mm')}</div></TableCell>);
      default:
        return (<TableCell><div style={styles.pendingText}>Bekliyor</div></TableCell>);
    }
  }

  render() {
    const { BoxClass,processInfos,processDetails,processSigners,steps,activeStep, isCancelAuth} = this.state;

      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
      }));

    return (
      <div>
        <Box sx={{ width: '100%' }}>
        <Stepper steps={steps} activeStep={activeStep} stepType={'active'}/>

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç İçeriği</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processInfos.map((row) => (
                      <StyledTableRow>
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
                <div className='sameLine' style={{ width: '10%'}}>
                  <Button onClick={this.handleViewDoc} style={styles.button} sx={{backgroundColor: '#386c99'}} variant="contained" >
                    Dosya İndir
                  </Button>
                </div>         
                <div className='sameLine' style={{ width: '10%'}} hidden={(!isCancelAuth)}>
                  <Button onClick={this.handleCancel} style={styles.button} sx={{backgroundColor: '#C8314D'}} variant="contained" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none"><g clip-path="url(#clip0_126_2364)"><path d="M11.6175 11.6175C11.1075 12.1275 10.2825 12.1275 9.7725 11.6175L6 7.845L2.2275 11.6175C1.7175 12.1275 0.8925 12.1275 0.3825 11.6175C-0.1275 11.1075 -0.1275 10.2825 0.3825 9.7725L4.155 6L0.3825 2.2275C-0.1275 1.7175 -0.1275 0.8925 0.3825 0.3825C0.8925 -0.1275 1.7175 -0.1275 2.2275 0.3825L6 4.155L9.7725 0.3825C10.2825 -0.1275 11.1075 -0.1275 11.6175 0.3825C12.1275 0.8925 12.1275 1.7175 11.6175 2.2275L7.845 6L11.6175 9.7725C12.1125 10.2675 12.1125 11.1075 11.6175 11.6175Z" fill="#fff"/></g><defs><clipPath id="clip0_126_2364"><rect width="12" height="12" fill="white"/></clipPath></defs></svg> 
                  <span className='d-block' style={{marginLeft: '8px'}}>İptal Et</span>
                  </Button>
                </div>      
            </Box>
          </Grid>
          
          {/* buraya yeni iptal seçeneği eklenecek. iptal dialoğuna gidecek. */}

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç İmzacıları</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processSigners.map((row) => (
                      <StyledTableRow>
                        {this.getUserIcon(row.recordStatus)}
                        <TableCell component="th" scope="row" sx={styles.cellName} >               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                        {this.getUserApproveText(row.recordStatus,row.updateDate)}
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç Ayrıntıları</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processDetails.map((row) => (
                      <StyledTableRow>
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

        </Grid>
        </Box>
        <div>
        <CancelDialog open = {this.state.isCancelDialogOpen} handleChange = {(e) => this.handleChange(e)} 
            onClose = {(e) => this.handleCloseCancelDialog(e)} handleApprove = {(e) => this.handleApproveCancelDialog(e)}/>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(DetailPage);